import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-turns-desk-reset-card',
  templateUrl: './turns-desk-reset-card.component.html',
  styleUrls: ['./turns-desk-reset-card.component.scss']
})
export class TurnsDeskResetCardComponent implements OnInit, OnDestroy {

  @Input() desk;
  rebootDeskSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              public dialog: MatDialog) { }

  ngOnInit() { }

  public rebootDesk() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'IMPORTANT',
        messages: ['Desk turns will be reset and turns requested could be lost. This action cannot be reversed.', 'Do you want to reset it anyway?']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.rebootDeskSubscription = this.desksTurnsService.rebootDesk(this.desk.InternalId).subscribe(
          (res) => {
            this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
            this.desksTurnsService.refreshDesk();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.rebootDeskSubscription) { this.rebootDeskSubscription.unsubscribe(); }
  }
}
